import script from "./BookingDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./BookingDetailModal.vue?vue&type=style&index=0&id=ce918b0a&lang=css"

const __exports__ = script;

export default __exports__